// Storage utility functions for localStorage and JSON backup/restore

const STORAGE_KEY = 'finance_tracker_data';

// Default initial state
export const getDefaultState = () => ({
  // Removed initialBalance - now managed via transactions
  isOnboarded: false,
  transactions: [],
  people: [],
  lendings: [],
  borrowings: [],
  categories: [
    { id: 'cat_1', name: 'Food & Dining', icon: '🍔', color: '#ef4444' },
    { id: 'cat_2', name: 'Transportation', icon: '🚗', color: '#f97316' },
    { id: 'cat_3', name: 'Shopping', icon: '🛍️', color: '#eab308' },
    { id: 'cat_4', name: 'Entertainment', icon: '🎬', color: '#22c55e' },
    { id: 'cat_5', name: 'Bills & Utilities', icon: '💡', color: '#3b82f6' },
    { id: 'cat_6', name: 'Health', icon: '🏥', color: '#8b5cf6' },
    { id: 'cat_7', name: 'Salary', icon: '💰', color: '#10b981' },
    { id: 'cat_8', name: 'Freelance', icon: '💻', color: '#06b6d4' },
    { id: 'cat_9', name: 'Transfer', icon: 'arrows_left_right', color: '#6366f1' }, // Added Transfer category
    { id: 'cat_10', name: 'Other', icon: '📦', color: '#64748b' },
  ],
  tags: [
    { id: 'tag_1', name: 'Essential', color: '#ef4444' },
    { id: 'tag_2', name: 'Optional', color: '#f97316' },
    { id: 'tag_3', name: 'Recurring', color: '#8b5cf6' },
    { id: 'tag_4', name: 'One-time', color: '#3b82f6' },
  ],
  modes: [
    { id: 'mode_1', name: 'Cash', type: 'cash', icon: '💵' },
    { id: 'mode_2', name: 'Online', type: 'digital', icon: '💳' },
  ],
  recurringTransactions: [],
  lastRecurringCheck: null,
  currency: '₹',
});

// Save data to localStorage
export const saveToLocalStorage = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving to localStorage:', error);
    return false;
  }
};

// Load data from localStorage
export const loadFromLocalStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  } catch (error) {
    console.error('Error loading from localStorage:', error);
    return null;
  }
};

// Export all data to JSON file
export const exportToJSON = (data) => {
  try {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `finance_tracker_backup_${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error('Error exporting to JSON:', error);
    return false;
  }
};

// Import data from JSON file
export const importFromJSON = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target.result);
        // Validate the data structure
        if (typeof data === 'object' && data !== null) {
          resolve(data);
        } else {
          reject(new Error('Invalid data format'));
        }
      } catch (error) {
        reject(new Error('Failed to parse JSON file'));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};

// Clear all data
export const clearAllData = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing data:', error);
    return false;
  }
};
